export const currentFormulaSelector = (state) => state.dataEntry.ui.formula;
export const focusedCellCoordsSelector = (state) => state.dataEntry.ui.focusedCell;
export const selectedRegionsSelector = (state) => state.dataEntry.ui.selectedRegions;
export const formulaInsertDataSelector = (state) => state.dataEntry.ui.formulaInsertData;
export const editModeSelector = (state) => state.dataEntry.ui.editMode;
export const formulaStylesSelector = (state) => state.dataEntry.ui.formulaStyles;
export const constantStylesSelector = (state) => state.dataEntry.ui.constantStyles;
export const defaultFormatSelector = (state) => state.dataEntry.ui.defaultFormat;
